export default __webpack_public_path__ + "static/media/forgottencityunchained.276eb1aa.jpg";